import React, { useState } from "react";
import moment from "moment";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { Grid, Select, FormControl, InputLabel } from "@mui/material";
import TextField from "@mui/material/TextField";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import API, { URL_PATH } from "../../services/API";
import IsolatedStatusModal from "../../components/StatusModal";
import Header from "../../components/Header";
import Toast from "../../components/Toast"


function SwitchButtons() {
  const inputProps = {
    style: {
      color: "gray",
    },
  };

  const [loading, setLoading] = React.useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    title: "",
    text: "",
    icon: "",
  });
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "success"
  });

  const handleCloseToast = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setToast({...toast, open: false});
  };

  const saveConfig = async () => {
    const fd = {};

    fd.pickup_token_payment = pickupTokenPayment;
    fd.book_table_token_payment = bookTableTokenPayment;
    fd.book_hall_token_payment = bookHallTokenPayment;
    fd.waiting_room_token_payment = waitingRoomTokenPayment;
    fd.gst_percentage = gstPercentage;

    console.log("fd", fd);

    const { status, message } = await API(
      this,
      "post",
      URL_PATH.saveConfig,
      fd
    );

    if (status === "success") {
      setToast({
        open: true,
        message: "Config saved successfully",
        severity: "success"
      });
    } else {
      setToast({
        open: true,
        message: message || "Failed to save config",
        severity: "error"
      });
    }
  };

  const getData = async () => {
    const response = await API(this, "get", URL_PATH.GET_PREFERENCES);
    const { status, message, data } = response;

    const { hotelConfig, activeHours, timezones } = data;

    setDineInAvailable(hotelConfig.dine_in_available);
    setPickupAvailable(hotelConfig.pickup_available);
    setPickupNowOptAvailable(hotelConfig.pickup_now_opt_available);
    setPickupLaterOptAvailable(hotelConfig.pickup_later_opt_available);
    setBookTableAvailable(hotelConfig.book_table_available);
    setBookHallAvailable(hotelConfig.book_hall_available);

    setBookTableTokenPayment(hotelConfig.book_table_token_payment);
    setBookHallTokenPayment(hotelConfig.book_hall_token_payment);
    setWaitingRoomTokenPayment(hotelConfig.waiting_room_token_payment);
    setPickupTokenPayment(hotelConfig.pickup_token_payment);
    setCloseForDay(hotelConfig.close_for_day);
    setGstPercentage(hotelConfig.gst_percentage);

    setLoading(false);

    setAvailableTimeZones(timezones);
  };

  React.useEffect(() => {
    getData();
  }, []);

  const [dineInAvailable, setDineInAvailable] = React.useState(false);
  const [pickupAvailable, setPickupAvailable] = React.useState(false);
  const [pickupNowOptAvailable, setPickupNowOptAvailable] =
    React.useState(false);
  const [pickupLaterOptAvailable, setPickupLaterOptAvailable] =
    React.useState(false);
  const [bookTableAvailable, setBookTableAvailable] = React.useState(false);
  const [bookHallAvailable, setBookHallAvailable] = React.useState(false);

  const [pickupTokenPayment, setPickupTokenPayment] = React.useState(0);
  const [bookTableTokenPayment, setBookTableTokenPayment] = React.useState(0);
  const [bookHallTokenPayment, setBookHallTokenPayment] = React.useState(0);
  const [waitingRoomTokenPayment, setWaitingRoomTokenPayment] =
    React.useState(0);
  const [closeForDay, setCloseForDay] = React.useState(false);
  const [gstPercentage, setGstPercentage] = React.useState(0);
  const [timeZone, setTimeZone] = React.useState(null);
  const [availableTimeZones, setAvailableTimeZones] = React.useState([]);
  const [activeHours, setActiveHours] = React.useState([]);
  const [timezones, setTimezones] = React.useState([]);
  const [isTimePickerVisible, setIsTimePickerVisible] = React.useState(false);
  const [timeIndex, setTimeIndex] = React.useState(null);
  const [timetype, setTimetype] = React.useState("");
  const [mounted, setMounted] = React.useState(false);

  const handleDineInAvailable = (event) => {
    setDineInAvailable(event.target.checked);
  };

  const handlePickupNowOptAvailable = (event) => {
    setPickupNowOptAvailable(event.target.checked);
  };

  const handlePickupLaterOptAvailable = (event) => {
    setPickupLaterOptAvailable(event.target.checked);
  };

  const handleBookTableAvailable = (event) => {
    setBookTableAvailable(event.target.checked);
  };

  const handleBookHallAvailable = (event) => {
    setBookHallAvailable(event.target.checked);
  };

  const handleBookTableTokenPayment = (event) => {
    setBookTableTokenPayment(event.target.value);
  };

  const handlePickupTokenPayment = (event) => {
    setPickupTokenPayment(event.target.value);
  };

  const handleBookHallTokenPayment = (event) => {
    setBookHallTokenPayment(event.target.value);
  };

  const handleWaitingRoomTokenPayment = (event) => {
    setWaitingRoomTokenPayment(event.target.value);
  };

  const handleCloseForDay = (event) => {
    setCloseForDay(event.target.checked);
  };

  const handleGstPercentage = (event) => {
    setGstPercentage(event.target.value);
  };

  const handleTimeZone = (event) => {
    setTimeZone(event.target.value);
  };

  if (loading) return <Box>
    <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                padding: 15,
                // backgroundColor: "rgba(0,0,0,0.5)",
                // backgroundColor: Colors.pageBgColor,
                alignSelf: "center",
                borderRadius: "50%",
              }}
            >
              <img
                src={"/Etable Loading.gif"}
                style={{
                 width:180 ,
                                  height:180,
                  // borderRadius: "70px",
                }}
                className="fade-in"
              />
            </div>
          </div>
  </Box>


  return (
    <>
                            <Header title="Tax & Tokens" />

    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
      }}
    >
      <Box
        sx={{
          border: "1px solid #FFC857",
          borderRadius: "5px",
          maxWidth: "500px", // Increased from 400px to 450px
          width: "100%",
          padding: "30px",
        }}
      >
        <Box sx={{ mb: 3 }}>
          <TextField
            label="Book Table Token Amount"
            fullWidth
            variant="outlined"
            value={bookTableTokenPayment}
            onChange={(e) => setBookTableTokenPayment(e.target.value)}
          />
        </Box>
{/* 
        <Box sx={{ mb: 3 }}>
          <TextField
            label="Pickup Token Amount"
            fullWidth
            variant="outlined"
            value={pickupTokenPayment}
            onChange={(e) => setPickupTokenPayment(e.target.value)}
          />
        </Box> */}

        <Box sx={{ mb: 3 }}>
          <TextField
            label="Book Hall Token Amount"
            fullWidth
            variant="outlined"
            value={bookHallTokenPayment}
            onChange={(e) => setBookHallTokenPayment(e.target.value)}
          />
        </Box>

        <Box sx={{ mb: 3 }}>
          <TextField
            label="Waiting Room Order Token Amount"
            fullWidth
            variant="outlined"
            value={waitingRoomTokenPayment}
            onChange={(e) => setWaitingRoomTokenPayment(e.target.value)}
          />
        </Box>

        <Box sx={{ mb: 3 }}>
          <TextField
            label="GST Percentage"
            fullWidth
            variant="outlined"
            value={gstPercentage}
            onChange={(e) => setGstPercentage(e.target.value)}
          />
        </Box>

        <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#FFC857",
              fontWeight:"700",
              color: "#000",
              "&:hover": {
                backgroundColor: "#E6B54E",
              },
              padding: "10px 20px", // Increased button size
            }}
            onClick={saveConfig}
          >
            Save
          </Button>
        </Box>
      </Box>


    </Box>
          {/* { && ( */}
          <Toast
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        handleClose={handleCloseToast}
      />
          {/* )} */}
    </>
    
  )
}

export default SwitchButtons

